<template>
  <p class="ba b--white bg-animate hover-bg-blue dib link pointer ph4 pv3 tc ttu">{{ content }}</p>
</template>

<script>
export default {
  name: 'Button',

  props: {
    content: {
      type: String,
      required: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/VButton.vue